import { ChannelClassificationInput } from '@api/generated/graphql';
import { BackendCallType, BackendCallTypeName } from '@constants/callTypes';

type CallTypeInfo = Partial<
  Pick<ChannelClassificationInput, 'typeId' | 'typeName'>
>;

/**
 * Determines whether to include typeId and typeName in the classification payload.
 *
 * For active calls (not yet completed), returns empty object to defer classification to backend.
 * For completed calls, returns typeId/typeName based on isLead.
 *
 * @param isLead - Whether the call reason is marked as a lead
 * @param completedAt - The backend completedAt timestamp (null if call hasn't ended)
 * @returns Object with optional typeId and typeName fields
 */
export const getCallType = (
  isLead: boolean,
  completedAt?: string | null,
): CallTypeInfo => {
  // For active calls (not yet completed), defer classification to backend
  if (!completedAt) {
    return {};
  }

  const callType = isLead
    ? BackendCallType[BackendCallTypeName.Unbooked]
    : BackendCallType[BackendCallTypeName.NotLead];

  return {
    typeId: String(callType.id),
    typeName: callType.name,
  };
};
